import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { playersResponseSchema } from '../types';

export const receivePlayersPatched = createReceive(
	'players-patched',
	zodContract(playersResponseSchema),
);
